<template>
  <v-row>
    <v-col
      cols="12"
      md="8"
      class="d-none d-md-block"
      >
      <v-data-table
        class="table--events"
        :headers="headers"
        :items="events"
        @click:row="mapIt"
        hide-default-footer
        disable-pagination
      >
        <template v-slot:item.event="{ item }">
          <v-icon color="success">
            mdi-circle-slice-8
          </v-icon>
        </template>
        <template style="background-color:red" v-slot:item.from="{ item }">
          {{ _.get(item, 'from.postalCode') }}
          {{ _.get(item, 'from.city') }}
          {{ _.get(item, 'from.country') }}
        </template>
        <template v-slot:item.description="{ item }">
          {{ translateByScope(_.get(item, 'description')) }}
        </template>
        <template v-slot:item.closeDate="{ item }">
          {{ _.get(item, 'closeDate') | datetime }}
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="12" class="d-block d-md-none" order="12" order-sm="1">
      <v-expansion-panels focusable>
        <v-expansion-panel
          v-for="(event, index) in events"
          :key="index"
        >
          <v-expansion-panel-header @click="mapIt(event)">
            {{ event.description }}
            <v-icon color="success" class="justify-end">
              mdi-circle-slice-8
            </v-icon>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-row>
              <h5>When</h5>
              <v-spacer></v-spacer>
              <p>{{ _.get(event, 'closeDate') | datetime }}</p>
            </v-row>
            <v-row>
              <h5>Where</h5>
              <v-spacer></v-spacer>
              <p>{{ _.get(event, 'from.country') }}</p>
            </v-row>
            <v-row>
              <h5>Comment</h5>
              <v-spacer></v-spacer>
              <p>{{ _.get(event, 'remarks') }}</p>
            </v-row>
            <v-row>
              <h5>Recipient name</h5>
              <v-spacer></v-spacer>
              <p>{{ _.get(event, 'value') }}</p>
            </v-row>
            <v-row>
              <h5>Reason</h5>
              <v-spacer></v-spacer>
              <p>{{ _.get(event, 'reason') }}</p>
            </v-row>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
    <v-col cols="12" md="4" class="map" order="1" order-sm="12">
      <div v-if="useIoTMap" class="map__holder">
        <app-map
          :iot="[hits, air]"
          :dest="sites.B"
          :update="sites.uid"
          :done="isComplete(steps.slice().pop())"
        />
      </div>
      <div v-else ref="map" class="map__holder">
        <app-map
          :site-a="sites.A"
          :site-b="sites.B"
          :update="sites.uid"
          :iot="[hits, air]"
        />
      </div>
      <div class="py-4" v-if="eventSelected">
        <p class="mb-0">
          <span
            class="grey--text mr-2"
          >Delivery order:</span>
          <span>{{ _.get(result, 'customer') }}</span>
        </p>
        <p class="mb-0">
          <span
            class="grey--text mr-2"
          >Customer delivery address:</span>
          <span>
            {{ _.get(order, 'from.postalCode') }}
            {{ _.get(order, 'from.city') }}
            {{ _.get(order, 'from.country') }}
          </span>
        </p>
        <p class="mb-0">
          <span
            class="grey--text mr-2"
          >Recipient name:</span>
          <span>{{ _.get(order, 'value') }}</span>
        </p>
        <p class="mb-0">
          <span
            class="grey--text mr-2"
          >Delivery date:</span>
          <span>{{ _.get(order, 'closeDate') | datetime }}</span>
        </p>
      </div>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex';
import { get, values } from 'lodash';
import { oftype } from '@/utils';
import locationMixin from '@/mixins/location.mixin';

export default {
  name: 'app-business-scope-events',
  mixins: [locationMixin],
  data() {
    return {
      order: { },
      eventSelected: false,
    };
  },
  computed: {
    ...mapState({
      result: 'Order',
      iotAccess: 'IOTAccess',
      scope: 'Scope',
    }),
    air() {
      // eslint-disable-next-line
      return this.result.hits
        ? this.result.hits.filter(h => h._source.air)
        : [];
    },
    tracker() {
      // eslint-disable-next-line
      return this.result.hits
        ? this.result.hits.filter(h => h._source.tracker)
        : [];
    },
    trackerHits() {
      /* eslint-disable */
      return values(this.tracker.reduce((holder, current, i) => {
        const tracker = current._source.tracker;

        if (!holder[tracker.deviceId]) {
          holder[tracker.deviceId] = {
            text: `${this.result.shipment} - ${tracker.deviceId}`,
            value: tracker.deviceId,
            hits: [],
          };
        }
        holder[tracker.deviceId].hits.push(current);

        return holder;
      }, { })).map(v => v);
      /* eslint-enable */
    },
    useIoTMap() {
      return (
        this.result.hits
        && this.iotAccess
        && this.trackerHits[0]
      );
    },
    hits() {
      if (this.useIoTMap) {
        return {
          trackers: this.trackerHits,
        };
      }

      return [];
    },
    steps() {
      const orders = get(this.order, 'orders');
      if (orders) {
        return (oftype(orders, 'Array') ? orders : [orders])
          .filter(o => this.$lang.translate(`details.majorSteps.${o.type}`));
      }
      return [];
    },
    events() {
      const { events } = this.result;

      if (events) {
        return (oftype(events, 'Array') ? events : [events])
          .filter(e => get(e, 'closeDate'))
          .map((e) => {
            const a = { ...e };

            if (!['Align'].includes(this.scope.name)) {
              a.reason = a.remarks;
              a.remarks = '';
            }

            return a;
          });
      }

      return [];
    },
    headers() {
      return [
        {
          text: this.$lang.translate('events.table.status'),
          sortable: false,
          value: 'event',
        },
        {
          text: this.$lang.translate('events.table.when'),
          value: 'closeDate',
          width: '20%',
        },
        {
          text: this.$lang.translate('events.table.where'),
          sortable: false,
          value: 'from',
        },
        {
          text: this.$lang.translate('events.table.event'),
          sortable: false,
          value: 'description',
        },
        {
          text: this.$lang.translate('events.table.comment'),
          sortable: false,
          value: 'remarks',
        },
        {
          text: this.$lang.translate('events.table.recipient'),
          sortable: false,
          value: 'value',
        },
        {
          text: this.$lang.translate('events.table.reason'),
          sortable: false,
          value: 'reason',
        },
      ];
    },
  },
  methods: {
    /**
     * Only for LVMH, we do a translation of the values that comes from MPO (cuz
     * they are in french in some cases), we only can apply for a certain known
     * values:
     *
     * Retardé -> Delayed
     * Livré -> Delivered
     * Différé -> Departure delay
     * Départ -> Departed
     * Non livré -> Delivery not completed
     *
     * @param {String} comment
     * @returns {String}
     */
    translateByScope(comment) {
      if (this.scope.name === 'LVMH') {
        return {
          Retardé: 'Delayed',
          Livré: 'Delivered',
          Différé: 'Departure delay',
          Départ: 'Departed',
          'Non livré': 'Delivery not completed',
        }[comment] || comment;
      }

      return comment;
    },
    isComplete(step) {
      switch (this.scope.system) {
        case 'Zenith':
          return window._.get(step, 'complete') === '1';
        default:
          return window._.get(step, 'dates.actualEnd') !== null;
      }
    },
    mapIt(item) {
      if (item.from.country !== '') {
        this.eventSelected = true;
        this.order = item;
        const RCountry = { city: item.from.city, country: item.from.country.slice(0, 2) };
        this.sites.A = RCountry;
        return;
      }
      this.eventSelected = false;
      this.order = this.result;
    },
  },
  created() {
    this.order = this.result;
  },
};
</script>
